  import React, { useMemo, useState } from "react";
  import axios from "axios";
  import * as XLSX from "xlsx";
  import "./InformeAusenciasDocentes.css";
  import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario";
  import comprueboPermisos from "../tools/comprueboPermisos";

  const API =
    "https://wwwa.isepsantafe.net.ar/expedientes/devuelveInformeEstadisticoAusenciasDocentes";

  const hoyISO = () => {
    const hoy = new Date();
    const anio = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${anio}-${mes}-${dia}`;
  };

  const inicioAnioISO = () => {
    const hoy = new Date();
    return `${hoy.getFullYear()}-01-01`;
  };

  const numero = (valor) =>
    Number(valor || 0).toLocaleString("es-AR");

  const fechaAR = (valor) => {
    if (!valor) return "-";
    const texto = String(valor).slice(0, 10);
    const partes = texto.split("-");
    if (partes.length !== 3) return texto;
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const textoEstado = (estado) => {
    const valor = String(estado || "").trim();
    if (!valor) return "Sin estado";
    if (valor === "En Revision") return "En revisión";
    return valor;
  };

  const InformeAusenciasDocentes = ({ onClose })  => {
    const Usuario = ObtieneDatosCookies() || {};

    const todasLasEscuelas = [
      { value: "Escuela de Policia", label: "Escuela de Policía", permiso: "Escuela de Policia" },
      { value: "Escuela de Investigaciones", label: "Escuela de Investigaciones", permiso: "Escuela de Investigaciones" },
      { value: "Escuela Superior", label: "Escuela Superior", permiso: "Escuela Superior" },
      { value: "Escuela de Especialidades", label: "Escuela de Especialidades", permiso: "Escuela de Especialidades" },
      { value: "Extension Comunitaria", label: "Extensión Comunitaria", permiso: "Extension Comunitaria" },
      { value: "Educacion a Distancia", label: "Educación a Distancia", permiso: "Educacion a Distancia" },
      { value: "Extracurricular", label: "Extracurricular", permiso: "Extracurricular" },
    ];

    const puedeVerTodasLasEscuelas = comprueboPermisos(
      Usuario.funcion,
      "Veo todas las escuelas Crear Cursos"
    );

    const escuelasPermitidas = puedeVerTodasLasEscuelas
      ? todasLasEscuelas
      : todasLasEscuelas.filter((escuela) =>
          comprueboPermisos(Usuario.funcion, escuela.permiso)
        );

    const opcionesEscuela = [
      ...(puedeVerTodasLasEscuelas ? [{ value: "", label: "Todas" }] : []),
      ...escuelasPermitidas.map(({ value, label }) => ({ value, label })),
    ];

    const escuelaInicial = puedeVerTodasLasEscuelas
      ? ""
      : escuelasPermitidas[0]?.value || "";

    const puedeConsultarEscuelas =
      puedeVerTodasLasEscuelas || escuelasPermitidas.length > 0;

    const [filtros, setFiltros] = useState({
      fechaDesde: inicioAnioISO(),
      fechaHasta: hoyISO(),
      escuela: escuelaInicial,
      sede: "",
      curso: "",
      division: "",
      materia: "",
      docenteDni: "",
      tipoDeAusencia: "",
      estadoSanidad: "",
    });

    const [datos, setDatos] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState("");
    const [vista, setVista] = useState("escuela");

    const consultar = async () => {
      try {
        setCargando(true);
        setError("");

        const payload = Object.fromEntries(
          Object.entries(filtros).filter(
            ([, valor]) =>
              valor !== null &&
              valor !== undefined &&
              String(valor).trim() !== ""
          )
        );

        const response = await axios.post(API, payload, {
          withCredentials: true,
        });

        if (!response.data?.success) {
          throw new Error(
            response.data?.message ||
              "No se pudo generar el informe."
          );
        }

        setDatos(response.data);
      } catch (e) {
        console.error("Error informe ausencias docentes:", e);
        setDatos(null);
        setError(
          e.response?.data?.message ||
            e.message ||
            "No se pudo consultar el informe."
        );
      } finally {
        setCargando(false);
      }
    };

    const limpiarFiltros = () => {
      setFiltros({
        fechaDesde: inicioAnioISO(),
        fechaHasta: hoyISO(),
        escuela: escuelaInicial,
        sede: "",
        curso: "",
        division: "",
        materia: "",
        docenteDni: "",
        tipoDeAusencia: "",
        estadoSanidad: "",
      });
    };

    const resumen = datos?.resumenGeneral || {};

    const ranking = datos?.ranking || {};

    const tablas = useMemo(
      () => ({
        escuela: {
          titulo: "Por escuela",
          datos: datos?.porEscuela || [],
        },
        sede: {
          titulo: "Por sede",
          datos: datos?.porSede || [],
        },
        curso: {
          titulo: "Por curso",
          datos: datos?.porCurso || [],
        },
        division: {
          titulo: "Por división",
          datos: datos?.porDivision || [],
        },
        materia: {
          titulo: "Por materia",
          datos: datos?.porMateria || [],
        },
        docente: {
          titulo: "Por docente",
          datos: datos?.porDocente || [],
        },
      }),
      [datos]
    );

    const exportarExcel = () => {
      if (!datos) return;

      const wb = XLSX.utils.book_new();

      const resumenExcel = [
        {
          Indicador: "Avisos",
          Valor: resumen.totalAvisos || 0,
        },
        {
          Indicador: "Docentes únicos",
          Valor: resumen.docentesUnicos || 0,
        },
        {
          Indicador: "Días solicitados",
          Valor: resumen.diasSolicitados || 0,
        },
        {
          Indicador: "Días confirmados",
          Valor: resumen.diasConfirmados || 0,
        },
        {
          Indicador: "Clases afectadas",
          Valor: resumen.clasesAfectadas || 0,
        },
        {
          Indicador: "Con carpeta",
          Valor: resumen.conCarpeta || 0,
        },
        {
          Indicador: "Sin carpeta",
          Valor: resumen.sinCarpeta || 0,
        },
        {
          Indicador: "Justificados",
          Valor: resumen.justificados || 0,
        },
        {
          Indicador: "Injustificados",
          Valor: resumen.injustificados || 0,
        },
        {
          Indicador: "Pendientes",
          Valor: resumen.pendientes || 0,
        },
        {
          Indicador: "En revisión",
          Valor: resumen.enRevision || 0,
        },
      ];

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(resumenExcel),
        "Resumen"
      );

      const prepararAgrupacion = (lista) =>
        (lista || []).map((item) => ({
          Nombre: item.clave,
          Avisos: item.totalAvisos || 0,
          "Docentes únicos": item.docentesUnicos || 0,
          "Días solicitados": item.diasSolicitados || 0,
          "Días confirmados": item.diasConfirmados || 0,
          "Promedio días solicitados":
            item.promedioDiasSolicitados || 0,
          "Promedio días confirmados":
            item.promedioDiasConfirmados || 0,
          "Clases afectadas": item.clasesAfectadas || 0,
          "Con carpeta": item.conCarpeta || 0,
          "Sin carpeta": item.sinCarpeta || 0,
          Justificados: item.justificados || 0,
          Injustificados: item.injustificados || 0,
          Pendientes: item.pendientes || 0,
          "En revisión": item.enRevision || 0,
        }));

      const hojas = [
        ["Por escuela", datos.porEscuela],
        ["Por sede", datos.porSede],
        ["Por curso", datos.porCurso],
        ["Por division", datos.porDivision],
        ["Por materia", datos.porMateria],
        ["Por docente", datos.porDocente],
        ["Por tipo", datos.porTipoAusencia],
        ["Por estado", datos.porEstadoSanidad],
      ];

      hojas.forEach(([nombre, lista]) => {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet(
            prepararAgrupacion(lista)
          ),
          nombre.slice(0, 31)
        );
      });

      const detalleExcel = (datos.detalle || []).map(
        (item) => ({
          "Aviso ID": item.avisoId,
          "Carpeta ID": item.carpetaId,
          DNI: item.docenteDni,
          Docente: item.docente,
          Escuela: item.escuela,
          Sede: item.sede,
          Curso: item.curso,
          División: item.division,
          Materia: item.materia,
          "Asignación ID": item.asignacionId,
          "Tipo de ausencia": item.tipoDeAusencia,
          Desde: fechaAR(item.fechaDesde),
          Hasta: fechaAR(item.fechaHasta),
          "Días solicitados": item.diasSolicitados,
          "Días confirmados":
            item.diasConfirmados === null
              ? "Sin resolver"
              : item.diasConfirmados,
          "Clases afectadas": item.clasesAfectadas,
          "Tiene carpeta": item.tieneCarpeta ? "Sí" : "No",
          "Estado general": item.estadoGeneral,
          "Estado Sanidad": textoEstado(
            item.estadoSanidad
          ),
          "Estado Estudio": item.estadoEstudio,
          "Observaciones Sanidad":
            item.observacionesSanidad,
          Documentos: item.documentos,
        })
      );

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(detalleExcel),
        "Detalle"
      );

      const fechaNombre = hoyISO().replaceAll("-", "");
      XLSX.writeFile(
        wb,
        `Informe_Ausencias_Docentes_${fechaNombre}.xlsx`
      );
    };

    const tablaActual = tablas[vista];

    return (
      <div className="iad-container">
  <div className="iad-header">
    <div>
      <span className="iad-eyebrow">
        Control de avisos de ausentismo docente
      </span>

      <h2>Informe estadístico</h2>

      <p>
        Análisis por escuela, sede, curso,
        división, materia y docente.
      </p>
    </div>

    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <button
        type="button"
        className="iad-btn iad-btn-excel"
        onClick={exportarExcel}
        disabled={!datos}
      >
        Exportar Excel
      </button>

      <button
        type="button"
        onClick={onClose}
        title="Cerrar"
        aria-label="Cerrar"
        style={{
          width: "38px",
          height: "38px",
          border: "1px solid #d0d5dd",
          borderRadius: "8px",
          background: "#ffffff",
          color: "#344054",
          fontSize: "22px",
          fontWeight: "700",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  </div>


        <div className="iad-filtros">
          <Campo
            label="Desde"
            type="date"
            value={filtros.fechaDesde}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                fechaDesde: valor,
              }))
            }
          />

          <Campo
            label="Hasta"
            type="date"
            value={filtros.fechaHasta}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                fechaHasta: valor,
              }))
            }
          />

          <SelectCampo
            label="Escuela"
            value={filtros.escuela}
            opciones={opcionesEscuela}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                escuela: valor,
                sede: "",
              }))
            }
          />

          <SelectCampo
            label="Sede"
            value={filtros.sede}
            opciones={[
              { value: "", label: "Todas" },
              { value: "Rosario", label: "Rosario" },
              { value: "Recreo", label: "Recreo" },
            ]}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                sede: valor,
              }))
            }
          />

          <Campo
            label="Curso"
            value={filtros.curso}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                curso: valor,
              }))
            }
          />

          <Campo
            label="División"
            value={filtros.division}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                division: valor,
              }))
            }
          />

          <Campo
            label="Materia"
            value={filtros.materia}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                materia: valor,
              }))
            }
          />

          <Campo
            label="DNI docente"
            value={filtros.docenteDni}
            onChange={(valor) =>
              setFiltros((prev) => ({
                ...prev,
                docenteDni: valor,
              }))
            }
          />

          <div className="iad-campo">
            <label>Tipo de ausencia</label>
            <select
              value={filtros.tipoDeAusencia}
              onChange={(e) =>
                setFiltros((prev) => ({
                  ...prev,
                  tipoDeAusencia: e.target.value,
                }))
              }
            >
              <option value="">Todos</option>
              <option value="casoFortuito">
                Caso fortuito
              </option>
              <option value="razonesDeServicio">
                Razones de servicio
              </option>
              <option value="razonesMedicas">
                Razones médicas
              </option>
              <option value="motivosPersonales">
                Motivos personales
              </option>
            </select>
          </div>

          <div className="iad-campo">
            <label>Estado Sanidad</label>
            <select
              value={filtros.estadoSanidad}
              onChange={(e) =>
                setFiltros((prev) => ({
                  ...prev,
                  estadoSanidad: e.target.value,
                }))
              }
            >
              <option value="">Todos</option>
              <option value="Pendiente">
                Pendiente
              </option>
              <option value="En Revision">
                En revisión
              </option>
              <option value="Justificado">
                Justificado
              </option>
              <option value="Injustificado">
                Injustificado
              </option>
              <option value="Sin carpeta">
                Sin carpeta
              </option>
            </select>
          </div>

          <div className="iad-acciones-filtros">
            <button
              type="button"
              className="iad-btn iad-btn-consultar"
              onClick={consultar}
              disabled={cargando || !puedeConsultarEscuelas}
            >
              {cargando ? "Consultando..." : "Consultar"}
            </button>

            <button
              type="button"
              className="iad-btn iad-btn-limpiar"
              onClick={limpiarFiltros}
            >
              Limpiar
            </button>
          </div>
        </div>

        {!puedeConsultarEscuelas && (
          <div className="iad-error">
            El usuario no tiene permisos habilitados para consultar escuelas.
          </div>
        )}

        {error && (
          <div className="iad-error">
            {error}
          </div>
        )}

        {!datos && !error && !cargando && (
          <div className="iad-vacio">
            Seleccioná los filtros y presioná
            Consultar.
          </div>
        )}

        {datos && (
          <>
            <div className="iad-resumen-grid">
              <Resumen
                titulo="Avisos"
                valor={resumen.totalAvisos}
              />
              <Resumen
                titulo="Docentes"
                valor={resumen.docentesUnicos}
              />
              <Resumen
                titulo="Días solicitados"
                valor={resumen.diasSolicitados}
                destacado
              />
              <Resumen
                titulo="Días confirmados"
                valor={resumen.diasConfirmados}
              />
              <Resumen
                titulo="Clases afectadas"
                valor={resumen.clasesAfectadas}
              />
              <Resumen
                titulo="Justificados"
                valor={resumen.justificados}
                tipo="ok"
              />
              <Resumen
                titulo="Injustificados"
                valor={resumen.injustificados}
                tipo="danger"
              />
              <Resumen
                titulo="Pendientes"
                valor={
                  Number(resumen.pendientes || 0) +
                  Number(resumen.enRevision || 0)
                }
                tipo="warning"
              />
            </div>

            <div className="iad-ranking-grid">
              <Ranking
                titulo="Escuela con más días solicitados"
                item={
                  ranking.escuelaMayorDiasSolicitados
                }
                campo="diasSolicitados"
              />

              <Ranking
                titulo="Escuela con más avisos"
                item={
                  ranking.escuelaMayorCantidadAvisos
                }
                campo="totalAvisos"
              />

              <Ranking
                titulo="Sede con más días solicitados"
                item={
                  ranking.sedeMayorDiasSolicitados
                }
                campo="diasSolicitados"
              />

              <Ranking
                titulo="Docente con más días solicitados"
                item={
                  ranking.docenteMayorDiasSolicitados
                }
                campo="diasSolicitados"
              />
            </div>

            <div className="iad-tabs">
              {Object.entries(tablas).map(
                ([clave, config]) => (
                  <button
                    key={clave}
                    type="button"
                    className={
                      vista === clave
                        ? "iad-tab iad-tab-activa"
                        : "iad-tab"
                    }
                    onClick={() => setVista(clave)}
                  >
                    {config.titulo}
                  </button>
                )
              )}
            </div>

            <TablaAgrupada
              titulo={tablaActual.titulo}
              datos={tablaActual.datos}
            />

            <div className="iad-detalle-header">
              <h3>Detalle de registros</h3>
              <span>
                {numero(datos.cantidadRegistros)} registro(s)
              </span>
            </div>

            <div className="iad-tabla-wrapper">
              <table className="iad-tabla">
                <thead>
                  <tr>
                    <th>Docente</th>
                    <th>Escuela</th>
                    <th>Sede</th>
                    <th>Curso</th>
                    <th>División</th>
                    <th>Materia</th>
                    <th>Período</th>
                    <th>Días sol.</th>
                    <th>Días conf.</th>
                    <th>Sanidad</th>
                  </tr>
                </thead>

                <tbody>
                  {(datos.detalle || []).map(
                    (item, index) => (
                      <tr
                        key={
                          item.avisoId ||
                          `${item.docenteDni}-${index}`
                        }
                      >
                        <td>
                          <strong>
                            {item.docente}
                          </strong>
                          <small>
                            DNI {item.docenteDni}
                          </small>
                        </td>
                        <td>{item.escuela}</td>
                        <td>{item.sede}</td>
                        <td>{item.curso}</td>
                        <td>{item.division}</td>
                        <td>{item.materia}</td>
                        <td>
                          {fechaAR(item.fechaDesde)}
                          {" - "}
                          {fechaAR(item.fechaHasta)}
                        </td>
                        <td>
                          {numero(
                            item.diasSolicitados
                          )}
                        </td>
                        <td>
                          {item.diasConfirmados ===
                          null
                            ? "Sin resolver"
                            : numero(
                                item.diasConfirmados
                              )}
                        </td>
                        <td>
                          <Estado
                            estado={
                              item.estadoSanidad
                            }
                          />
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  };

  const Campo = ({
    label,
    type = "text",
    value,
    onChange,
  }) => (
    <div className="iad-campo">
      <label>{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) =>
          onChange(e.target.value)
        }
      />
    </div>
  );

  const SelectCampo = ({
    label,
    value,
    opciones,
    onChange,
  }) => (
    <div className="iad-campo">
      <label>{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {opciones.map((opcion) => (
          <option
            key={`${label}-${opcion.value}`}
            value={opcion.value}
          >
            {opcion.label}
          </option>
        ))}
      </select>
    </div>
  );

  const Resumen = ({
    titulo,
    valor,
    destacado,
    tipo = "",
  }) => (
    <div
      className={`iad-resumen ${
        destacado ? "iad-resumen-destacado" : ""
      } ${tipo ? `iad-resumen-${tipo}` : ""}`}
    >
      <strong>{numero(valor)}</strong>
      <span>{titulo}</span>
    </div>
  );

  const Ranking = ({
    titulo,
    item,
    campo,
  }) => (
    <div className="iad-ranking">
      <span>{titulo}</span>
      <strong>
        {item?.clave || "Sin datos"}
      </strong>
      <small>
        {item
          ? `${numero(item[campo])} ${
              campo === "totalAvisos"
                ? "aviso(s)"
                : "día(s)"
            }`
          : "-"}
      </small>
    </div>
  );

  const TablaAgrupada = ({
    titulo,
    datos,
  }) => (
    <div className="iad-bloque">
      <div className="iad-bloque-header">
        <h3>{titulo}</h3>
        <span>
          {numero(datos.length)} grupo(s)
        </span>
      </div>

      <div className="iad-tabla-wrapper">
        <table className="iad-tabla">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Avisos</th>
              <th>Docentes</th>
              <th>Días solicitados</th>
              <th>Días confirmados</th>
              <th>Promedio días</th>
              <th>Clases afectadas</th>
              <th>Justificados</th>
              <th>Injustificados</th>
              <th>Pendientes</th>
            </tr>
          </thead>

          <tbody>
            {(datos || []).map(
              (item, index) => (
                <tr
                  key={`${item.clave}-${index}`}
                >
                  <td>
                    <strong>
                      {item.clave}
                    </strong>
                  </td>
                  <td>
                    {numero(item.totalAvisos)}
                  </td>
                  <td>
                    {numero(
                      item.docentesUnicos
                    )}
                  </td>
                  <td>
                    {numero(
                      item.diasSolicitados
                    )}
                  </td>
                  <td>
                    {numero(
                      item.diasConfirmados
                    )}
                  </td>
                  <td>
                    {numero(
                      item.promedioDiasSolicitados
                    )}
                  </td>
                  <td>
                    {numero(
                      item.clasesAfectadas
                    )}
                  </td>
                  <td>
                    {numero(
                      item.justificados
                    )}
                  </td>
                  <td>
                    {numero(
                      item.injustificados
                    )}
                  </td>
                  <td>
                    {numero(
                      Number(
                        item.pendientes || 0
                      ) +
                        Number(
                          item.enRevision || 0
                        )
                    )}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const Estado = ({ estado }) => {
    const texto =
      String(estado || "").toLowerCase();

    let clase = "iad-estado";

    if (
      texto.includes("injustificado")
    ) {
      clase += " iad-estado-danger";
    } else if (
      texto.includes("justificado")
    ) {
      clase += " iad-estado-ok";
    } else if (
      texto.includes("revision") ||
      texto.includes("revisión") ||
      texto.includes("pendiente")
    ) {
      clase += " iad-estado-warning";
    } else {
      clase += " iad-estado-info";
    }

    return (
      <span className={clase}>
        {textoEstado(estado)}
      </span>
    );
  };

  export default InformeAusenciasDocentes;
